import { Button, Card, Flex } from "antd";
import ArrowRightIcon from "../../../../assets/icons/ArrowRightIcon";
import courseImg from "../../../../assets/images/CoursePic.jpg";
import { CourseCard } from "./CourseCard";

export default function TopSellingCourse() {
  return (
    <>
      <Card
        className="rounded-md shadow-md w-full bg-white mt-5"
        bodyStyle={{ padding: "18px" }}
      >
        <Flex justify="space-between" align="center" gap={8}>
          <div className="justify-start text-zinc-700 text-lg font-medium w-full">
            Top Selling Courses
          </div>
          <Button
            type="default"
            size="middle"
            className="btn-bordered-primary border
               border-zinc-200 hover:!border-zinc-200 focus:!border-zinc-200 active:!border-zinc-200"
          >
            View All <ArrowRightIcon />
          </Button>
        </Flex>

        <div
          className="
          grid 
          grid-cols-1 
          md:grid-cols-2 
          lg:grid-cols-4 
          gap-4
          mt-5
        "
        >
          {courses.map((course, index) => (
            <CourseCard key={index} {...course} />
          ))}
        </div>
      </Card>
    </>
  );
}

const courses = [
  {
    image: courseImg,
    title: "Master Figma: Getting started the Beginner to Pro Class",
    rating: 4.9,
    students: 85000,
    price: 356064,
  },
  {
    image: courseImg,
    title: "Master Figma: Getting started the Beginner to Pro Class",
    rating: 4.9,
    students: 85000,
    price: 356064,
  },
  {
    image: courseImg,
    title: "Master Figma: Getting started the Beginner to Pro Class",
    rating: 4.9,
    students: 85000,
    price: 356064,
  },
  {
    image: courseImg,
    title: "Master Figma: Getting started the Beginner to Pro Class",
    rating: 4.9,
    students: 85000,
    price: 356064,
  },
];
